var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"v-text-field-auth"},[_c('span',{staticClass:"v-text-field-auth__label"},[_vm._v(_vm._s(_vm.label))]),_c('input',{staticClass:"v-text-field-auth__input",class:{
      'v-text-field-auth__input--error': _vm.error,
    },attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }